jQuery(document).ready(function ($) {
	$("#buscador").on("submit", (e) => {
		var $empty_selects = $(this)
			.find(":select")
			.filter(function () {
				return $(this).val() === "";
			});

		$empty_selects.prop("disabled", true);
	});

	$("#slide-inicio").slick({
		autoplay: true,
		dots: false,
		arrows: false,
		infinite: true,
		speed: 1000,
		autoplaySpeed: 6000,
		slidesToShow: 1,
		slidesToScroll: 1,
		swipe: false,
		fade: true,
		pauseOnHover: false,
	});

	$("#slide-testimonios").slick({
		autoplay: true,
		dots: true,
		arrows: false,
		infinite: true,
		speed: 1000,
		autoplaySpeed: 6000,
		slidesToShow: 1,
		slidesToScroll: 1,
		pauseOnHover: false,
	});

	console.log($("#procesos-terminados").find(".elementor-posts"));
	$("#procesos-terminados").find(".elementor-posts").slick({
		autoplay: false,
		dots: false,
		arrows: true,
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		prevArrow:
			'<a href="javascript:void(null);" class="arrow prev-arrow">&lt;</a>',
		nextArrow:
			'<a href="javascript:void(null);" class="arrow next-arrow">&gt;</a>',
	});
});
